module.exports = __webpack_public_path__ + "img/chat.c9d6ebfe.svg";